import { FileWithTimestamp } from '@features/components/ClinicalData/types';
import { WithAttachmentsItem } from '@features/components/ClinicalData/components/ClinicalLog/LogItems/WithAttachmentsItem';

type WithChipAndPhotoItemProps = {
  event: string;
  description?: string;
  mediaFiles?: FileWithTimestamp[];
  yesNoValue?: boolean;
  shared?: boolean;
  onShareClick?: () => void;
};

export const WithChipAndPhotoItem = ({
  event,
  description,
  mediaFiles,
  yesNoValue,
  shared,
  onShareClick,
}: WithChipAndPhotoItemProps) => {
  return (
    <WithAttachmentsItem
      event={event}
      description={description}
      mediaFiles={mediaFiles?.length ? mediaFiles : []}
      yesNoValue={yesNoValue}
      showGalleryNavigation={false}
      customYesNoChipClassName="text-s-m"
      shared={shared}
      onShareClick={onShareClick}
    />
  );
};
